<template>
  <v-list class="py-0 pl-0">
    <draggable :list="list" group="list" @change="onDragChange"
      ><v-list-item v-for="item in list" :key="item" dense>
        <v-list-item-avatar size="20">
          <v-icon small>mdi-drag</v-icon>
        </v-list-item-avatar>
        <v-list-item-title>{{ item }}</v-list-item-title>
        <v-btn icon small class="mx-0" @click="onDeleteItem(item)">
          <v-icon x-small color="pink">mdi-close</v-icon>
        </v-btn>
      </v-list-item>
    </draggable>
  </v-list>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "simple-draggable-list",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },

  components: { draggable },

  data() {
    return {
      debug: false,
      list: this.value.length ? [...this.value] : [],
    };
  },

  methods: {
    onDragChange() {
      this.$emit("input", [...this.list]);
    },
    onDeleteItem(item) {
      const index = this.list.indexOf(item);
      this.list.splice(index, 1);
      this.$emit("input", [...this.list]);
    },
  },

  watch: {
    value(newVal) {
      this.list = [...newVal];
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/SimpleDraggableList.vue